import { isValidEmail } from './isValidEmail.js';

const forms = {
    isValidEmail
};

export { forms };
